// src/components/providers/compare-adaptex-context.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createContext } from "react";
// src/components/providers/compare-adaptex-arms.ts
var SHOW_PROMPT = "show-prompt";
var TOGGLE_PLACEMENT = "toggle-placement";
var TICK_BOX_VISIBILITY = "tick-box-visibility";
var SHOW_PROMPT_YES = "yes";
var SHOW_PROMPT_NO = "no";
var TOGGLE_PLACEMENT_NONE = "none";
var TOGGLE_PLACEMENT_FILTERS_SHEET = "filter-sheet";
var TOGGLE_PLACEMENT_SRP = "srp";
var TICK_BOX_VISIBILITY_TRUE = "true";
var TICK_BOX_VISIBILITY_FALSE = "false";
var _obj;
// src/components/providers/compare-adaptex-context.ts
var defaultState = {
    campaignId: "",
    payloadId: "",
    arms: (_obj = {}, _define_property(_obj, SHOW_PROMPT, SHOW_PROMPT_NO), _define_property(_obj, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_NONE), _define_property(_obj, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE), _obj),
    enabled: false
};
var defaultValue = [
    defaultState,
    function() {
        return void 0;
    }
];
var CompareAdaptExContext = createContext(defaultValue);
// src/components/providers/compare-adaptex-provider.tsx
import React, { useState } from "react";
import { useExperiment } from "@shared-ui/experiment-context";
// src/experiments.ts
var M1_EXPERIMENT = "M1_Web_SDUI_Property_Comparison_Tool_MVP_on_SRP";
// src/components/providers/compare-adaptex-provider.tsx
var Provider = CompareAdaptExContext.Provider;
var CompareAdaptExProvider = function(param) {
    var children = param.children;
    var bucket = useExperiment(M1_EXPERIMENT).exposure.bucket;
    var value = useState(function() {
        return _object_spread_props(_object_spread({}, defaultState), {
            enabled: bucket === 1
        });
    });
    return /* @__PURE__ */ React.createElement(Provider, {
        value: value
    }, children);
};
export { CompareAdaptExContext, CompareAdaptExProvider, SHOW_PROMPT, SHOW_PROMPT_NO, SHOW_PROMPT_YES, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE, TICK_BOX_VISIBILITY_TRUE, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_FILTERS_SHEET, TOGGLE_PLACEMENT_NONE, TOGGLE_PLACEMENT_SRP, defaultState };
//# sourceMappingURL=index.js.map